import { render, staticRenderFns } from "./CarouselTemplate.vue?vue&type=template&id=6a025d82&"
import script from "./CarouselTemplate.vue?vue&type=script&lang=js&"
export * from "./CarouselTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports